import * as React from 'react';
import {connect} from 'react-redux';
import BusinessObjectTypesGrid from "../../components/bo-core/grids/BusinessObjectTypesGrid";
import {DataTypesEnum} from "../../components/bo-core/enums/dataTypesEnum";
import BusinessObjectAttributesGrid from "../../components/bo-core/grids/BusinessObjectAttributesGrid";
import {fetchAllBusinessObjects} from '../../actions/boCoreActions';
import BusinessObjectRelationshipsGrid from "../../components/bo-core/grids/BusinessObjectRelationshipsGrid";
import BusinessObjectAttributeValueListGrid from "../../components/bo-core/grids/BusinessObjectAttributeValueListGrid";
import BusinessObjectsLayout from "./BusinessObjectsLayout";
import {EVENTS} from "../../config/boCore";
import * as toastr from "toastr";
import Hotkeys from 'react-hot-keys';
import Utils from "../../Utils";
import {BusinessObject} from "../../components/bo-core/models/BusinessObject";

interface Props {
    businessObjectsWrapper: any;

    fetchAllBusinessObjects(): void;
}

interface State {
    currentSlide: string;
    currentAttribute: any;
    currentRelationship: any;
    currentBusinessObject: any;
    currentAttributeValue: any;
}

declare const Slick: any;

class BusinessObjects extends React.Component<Props, State> {
    constructor(props) {
        super(props);
        this.state = {
            currentSlide: "typesSlide",
            currentBusinessObject: undefined,
            currentAttribute: undefined,
            currentRelationship: undefined,
            currentAttributeValue: undefined
        }
    }

    UNSAFE_componentWillMount(): void {
        $(document.body)
            .unbind(EVENTS.boView.setBusinessObject)
            .unbind(EVENTS.boView.setAttribute)
            .unbind(EVENTS.boView.setRelationship)
            .unbind(EVENTS.boView.setAttributeValue)
            .on(EVENTS.boView.setBusinessObject, (event: any) => {
                this.setState({currentBusinessObject: event.args.businessObject});
                event.preventDefault();
            })
            .on(EVENTS.boView.setAttribute, (event: any) => {
                this.setState({currentAttribute: event.args.attribute});
                event.preventDefault();
            })
            .on(EVENTS.boView.setRelationship, (event: any) => {
                this.setState({currentRelationship: event.args.relationship});
                event.preventDefault();
            })
            .on(EVENTS.boView.setAttributeValue, (event: any) => {
                this.setState({currentAttributeValue: event.args.attributeValue});
                event.preventDefault();
            });
        this.props.fetchAllBusinessObjects();
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot: any): void {
        if (this.props.businessObjectsWrapper !== prevProps.businessObjectsWrapper && this.props.businessObjectsWrapper) {
            Utils.eventDispatcher(EVENTS.boView.typesGrid.open, {
                data: this.props.businessObjectsWrapper,
                bocId: this.props.businessObjectsWrapper.getBusinessObjects(DataTypesEnum.ARRAY)[0].id
            });
        }
        this.initAccordeon();
    }

    componentWillUnmount() {
        if (Slick.GlobalEditorLock.isActive()) {
            Slick.GlobalEditorLock.cancelCurrentEdit();
        }
        Utils.$('[data-hasqtip]').qtip('destroy', true);
        $("#hide-nav-btn").off();
    };

    static addQtip($target, msg) {
        $target.qtip('destroy', true);
        $target.qtip({
            content: {
                title: function () {
                    return `<div style="width:360px; overflow:hidden; display:inline-block; text-overflow: ellipsis; white-space: nowrap;">Info</div>`
                },
                text: msg
            },
            show: {
                event: false,
                ready: true
            },
            hide: "click",
            position: {
                my: 'bottom center',
                at: 'top center',
                viewport: $(document.body)
            },
            style: {
                classes: 'qtip-red',
                width: 200
            }
        })
    }

    static appendQtipsToNode(data, grid, $equalTarget) {
        data.forEach((value: { valid: boolean; msg: string }, key: string) => {
                switch (key) {
                    case "equal": {
                        if (!value.valid) {
                            if (!$equalTarget.data("qtip"))
                                BusinessObjects.addQtip($equalTarget, value.msg);
                        } else {
                            $equalTarget.qtip('destroy', true);
                        }
                    }
                        break;
                    default: {
                        const cell = grid.getColumnIndex(key);
                        const row = grid.getSelectedRows()[0];
                        const $cellNode = Utils.$(grid.getCellNode(row, cell));
                        if (!value.valid) {
                            if (!$cellNode.data("qtip")) {
                                BusinessObjects.addQtip($cellNode, value.msg);
                            } else if ($cellNode.data('qtip').options.content.text !== value.msg) {
                                BusinessObjects.addQtip($cellNode, value.msg);
                            }
                        } else {
                            $cellNode.qtip('destroy', true);
                        }
                    }
                }
            }
        );
    }

    initAccordeon() {
        Utils.$('#accordeon').liteAccordion({
            responsive: true,
            minContainerWidth: 800,
            containerWidthOffset: 270,
            containerHeightOffset: 70,
            theme: "dark",
            rounded: false,
            enumerateSlides: true,
            synchronousResize: true,

            onSlideAnimComplete: () => {
                const $typesSlide = $("#typesSlide");
                const $attributesSlide = $("#attributesSlide");
                const $relationshipsSlide = $("#relationshipsSlide");
                const $valueListSide = $("#valueListSide");
                const currentSlide = $typesSlide.hasClass("selected") ? "typesSlide" : $attributesSlide.hasClass("selected") ? "attributesSlide" : $relationshipsSlide.hasClass("selected") ? "relationshipsSlide" : $valueListSide.hasClass("selected") ? "valueListSide" : "layoutSlide";
                this.setState({currentSlide});
                switch (currentSlide) {
                    case "typesSlide": {
                        const grid = $("#BusinessObjectTypesGrid").data("gridInstance");
                        const dataView = grid.getData();
                        const row = grid.getSelectedRows()[0] | 0;
                        if (!dataView.getItem(row).systemRequired) {
                            grid.setActiveCell(row, 1);
                        }
                    }
                        break;
                    case "attributesSlide": {
                        const grid = $("#BusinessObjectAttributesGrid").data("gridInstance");
                        const dataView = grid.getData();
                        const row = grid.getSelectedRows()[0] | 0;
                        if (!dataView.getItem(row).systemRequired && dataView.getItem(row).name !== "Name") {
                            grid.setActiveCell(row, 1);
                        }
                    }
                        break;
                    case "relationshipsSlide": {
                        const grid = $("#BusinessObjectRelationshipsGrid").data("gridInstance");
                        const dataView = grid.getData();
                        const row = grid.getSelectedRows()[0] | 1;
                        if (!dataView.getItem(row).systemRequired) {
                            grid.setActiveCell(row, 1);
                        }
                    }
                        break;
                    case "valueListSide": {
                        const grid = $("#BusinessObjectAttributeValueListGrid").data("gridInstance");
                        const dataView = grid.getData();
                        const row = grid.getSelectedRows()[0] | 0;
                        if (!dataView.getItem(row).systemRequired) {
                            grid.setActiveCell(row, 1);
                        }
                    }
                }
                Utils.$('[data-hasqtip]').qtip('destroy', true);
            },
            onBeforeTriggerSlide: (args, {currentSlide} = this.state) => {
                if (Slick.GlobalEditorLock.isActive) {
                    Slick.GlobalEditorLock.commitCurrentEdit();
                }
                if ($(args).prop("id") === "typesSlide") {
                    if (!this.checkBeforeTriggerSlide(currentSlide, {
                        type: "slide",
                        value: "#typesSlide"
                    })) return false;
                    let bocId;
                    if (this.state.currentBusinessObject) {
                        bocId = this.state.currentBusinessObject.id;
                    } else {
                        const businessObjects = this.props.businessObjectsWrapper.getBusinessObjects(DataTypesEnum.ARRAY);
                        if (businessObjects[0]) {
                            bocId = businessObjects[0].id;
                        } else {
                            bocId = undefined;
                        }
                    }
                    Utils.eventDispatcher(EVENTS.boView.typesGrid.open, {
                        data: this.props.businessObjectsWrapper,
                        bocId: bocId
                    });
                    return true;
                }
                if ($(args).prop("id") === "attributesSlide") {
                    if (this.state.currentBusinessObject) {
                        if (!this.checkBeforeTriggerSlide(currentSlide, {
                            type: "slide",
                            value: "#attributesSlide"
                        })) return;
                        const attributes = this.state.currentBusinessObject.getAttributes(DataTypesEnum.ARRAY);
                        Utils.eventDispatcher(EVENTS.boView.attributesGrid.open, {
                            attrId: this.state.currentAttribute ? this.state.currentAttribute.id : attributes[0] ? attributes[0].id : undefined
                        });
                        return true;
                    } else {
                        toastr.warning("Please select business object class.");
                    }
                }
                if ($(args).prop("id") === "relationshipsSlide") {
                    if (this.state.currentBusinessObject) {
                        if (!this.checkBeforeTriggerSlide(currentSlide, {
                            type: "slide",
                            value: "#relationshipsSlide"
                        })) return false;
                        Utils.eventDispatcher(EVENTS.boView.relationshipsGrid.open, {
                            currentBusinessObject: this.state.currentBusinessObject,
                            currentRelationship: this.state.currentRelationship
                        });
                        return true;
                    } else {
                        toastr.warning("Please select business object class.");
                    }
                }
                if ($(args).prop("id") === "valueListSide") {
                    if (this.state.currentBusinessObject && this.state.currentAttribute && this.state.currentAttribute.id !== -1 && this.state.currentAttribute.type === "value list") {
                        if (!this.checkBeforeTriggerSlide(currentSlide, {
                            type: "slide",
                            value: "#valueListSide"
                        })) return false;
                        const values = this.state.currentAttribute.attributeValues;
                        Utils.eventDispatcher(EVENTS.boView.valueListGrid.open, {
                            valueId: values[0] ? values[0].id : undefined
                        });
                        BusinessObject.enableButton("value-list-merge-btn");
                        BusinessObject.enableButton("value-list-import-btn");
                        return true;
                    } else {
                        if (!this.state.currentBusinessObject) {
                            toastr.warning("Please select business object class.");
                        } else if (!this.state.currentAttribute || this.state.currentAttribute.type !== "value list") {
                            toastr.warning("Please select attribute of type \"value list\".");
                        } else if (this.state.currentAttribute.id === -1) {
                            toastr.warning("Before add attribute value, save the attribute.");
                        }
                    }
                }
                if ($(args).prop("id") === "layoutSlide") {
                    if (this.props.businessObjectsWrapper && this.state.currentBusinessObject) {
                        if (!this.checkBeforeTriggerSlide(currentSlide, {
                            type: "slide",
                            value: "#layoutSlide"
                        })) return false;
                        Utils.eventDispatcher(EVENTS.boView.objectsLayout.open, {
                            businessObjectsWrapper: this.props.businessObjectsWrapper,
                            currentBusinessObject: this.state.currentBusinessObject
                        });
                        return true
                    } else {
                        toastr.warning("Please select business object class.");
                    }
                }
                return false;
            },
            onTriggerSlide: () => {

            }
        });

        $("#hide-nav-btn").on("click", function () {
            const core = $("#accordeon").data("coreInstance");
            if (!$(document.body).hasClass("mini-navbar")) {
                core.setSlideWidth(window.innerWidth - 120);
            } else {
                core.setSlideWidth(window.innerWidth - 270);
            }
        });
    }

    checkBeforeTriggerSlide = (currentSlide, args) => {
        switch (currentSlide) {
            case "typesSlide": {
                if (this.state.currentBusinessObject && this.props.businessObjectsWrapper.hasBusinessObject(this.state.currentBusinessObject.id)) {
                    const businessObject = this.props.businessObjectsWrapper.getBusinessObject(this.state.currentBusinessObject.id);
                    if (!businessObject.equal(this.state.currentBusinessObject)) {
                        confirm(this, businessObject.clone(), "typesSlide");
                        return false;
                    }
                } else if (this.state.currentBusinessObject && this.state.currentBusinessObject.id === -1) {
                    const businessObject = this.props.businessObjectsWrapper.getBusinessObjects(DataTypesEnum.ARRAY)[0];
                    confirm(this, businessObject ? businessObject.clone() : null, "typesSlide");
                    return false;
                }
            }
                break;
            case "attributesSlide": {
                if (this.state.currentAttribute && this.state.currentBusinessObject.hasAttribute(this.state.currentAttribute.id)) {
                    const attribute = this.state.currentBusinessObject.getAttribute(this.state.currentAttribute.id);
                    if (!attribute.equal(this.state.currentAttribute)) {
                        confirm(this, attribute.clone(), "attributesSlide");
                        return false;
                    }
                } else if (this.state.currentAttribute && this.state.currentAttribute.id === -1) {
                    const attribute = this.state.currentBusinessObject.getAttributes(DataTypesEnum.ARRAY)[0];
                    confirm(this, attribute ? attribute.clone() : null, "attributesSlide");
                    return false;
                }
            }
                break;
            case "relationshipsSlide": {
                if (this.state.currentRelationship && this.state.currentBusinessObject.hasRelationship(this.state.currentRelationship.id)) {
                    const relationship = this.state.currentBusinessObject.getRelationship(this.state.currentRelationship.id);
                    if (!relationship.equal(this.state.currentRelationship)) {
                        confirm(this, relationship.clone(), "relationshipsSlide");
                        return false;
                    }
                } else if (this.state.currentRelationship && this.state.currentRelationship.id) {
                    const relationship = this.state.currentBusinessObject.getRelationships(DataTypesEnum.ARRAY)[0];
                    confirm(this, relationship ? relationship.clone() : null, "relationshipsSlide");
                    return false;
                }
            }
                break;
            case "valueListSide": {
                if (this.state.currentAttributeValue && this.state.currentAttribute.hasAttributeValue(this.state.currentAttributeValue.id)) {
                    const attrValue = this.state.currentAttribute.getAttributeValue(this.state.currentAttributeValue.id);
                    if (!attrValue.equal(this.state.currentAttributeValue)) {
                        confirm(this, attrValue.clone(), "valueListSide");
                        return false;
                    }
                } else if (this.state.currentAttribute && this.state.currentAttribute.id !== -1 && this.state.currentAttributeValue && this.state.currentAttributeValue.id) {
                    const attributeValue = this.state.currentAttribute.getAttributeValues(DataTypesEnum.ARRAY)[0];
                    confirm(this, attributeValue ? attributeValue.clone() : null, "valueListSide");
                    return false;
                }
            }
        }

        function confirm(self, obj, slide) {
            Utils.$.confirm({
                title: 'Confirm ?',
                keyboardEnabled: true,
                escapeKey: 'cancel',
                backgroundDismiss: false,
                content: "If you leave the slide your changes won't be saved.Do you still want to leave ?",
                type: 'red',
                theme: 'dark',
                typeAnimated: false,
                buttons: {
                    ok: {
                        text: "Yes!",
                        btnClass: 'btn-danger',
                        keys: ['enter'],
                        action: () => {
                            switch (slide) {
                                case "typesSlide": {
                                    self.setState({currentBusinessObject: obj})
                                }
                                    break;
                                case "attributesSlide": {
                                    self.setState({currentAttribute: obj})
                                }
                                    break;
                                case "relationshipsSlide": {
                                    self.setState({currentRelationship: obj})
                                }
                                    break;
                                case "valueListSide": {
                                    self.setState({currentAttributeValue: obj})
                                }
                            }
                            switch (args.type) {
                                case "location": {
                                    window.location.href = `${process.env.ENV_PREFIX}/${args.value.pathname}`;
                                }
                                    break;
                                case"slide": {
                                    $(args.value).trigger("click.liteAccordion");
                                }

                            }
                            BusinessObject.enableButton("value-list-merge-btn");
                            BusinessObject.enableButton("value-list-import-btn");
                        }
                    },
                    cancel: () => {
                    }
                }
            });
        }

        return true;
    };

    onKeyDown(keyName, e, handle, {currentSlide} = this.state) {
        switch (currentSlide) {
            case "typesSlide": {
                switch (keyName) {
                    case "ctrl+s":
                        $("#types-save-btn").trigger("click");
                        break;
                    case "ctrl+delete":
                        $("#types-delete-btn").trigger("click");
                        break;
                }
            }
                break;
            case "attributesSlide": {
                switch (keyName) {
                    case "ctrl+s":
                        $("#attributes-save-btn").trigger("click");
                        break;
                    case "ctrl+delete":
                        $("#attributes-delete-btn").trigger("click");
                        break;
                }
            }
                break;
            case "relationshipsSlide": {
                switch (keyName) {
                    case "ctrl+s":
                        $("#relationship-save-btn").trigger("click");
                        break;
                    case "ctrl+delete":
                        $("#relationship-delete-btn").trigger("click");
                        break;
                }
            }
                break;
            case "valueListSide": {
                switch (keyName) {
                    case "ctrl+s":
                        $("#value-list-save-btn").trigger("click");
                        break;
                    case "ctrl+delete":
                        $("#value-list-delete-btn").trigger("click");
                        break;
                }
            }
                break;

        }
        e.preventDefault();
    }

    render() {
        const {businessObjectsWrapper} = this.props, {currentBusinessObject, currentAttribute, currentRelationship, currentAttributeValue} = this.state;
        if (!businessObjectsWrapper) {
            return null;
        }
        return (
            <Hotkeys
                keyName="ctrl+s,ctrl+delete"
                onKeyDown={this.onKeyDown.bind(this)}
            >
                <div style={{height: "100%",  background: '#23282A'}} className={"container-fluid"}>
                    <div id="accordeon">
                        <ol>
                            <li>
                                <h2 id={"typesSlide"}>
                                    <span style={{fontSize: 15}}>Types</span></h2>
                                <div>
                                    <BusinessObjectTypesGrid currentBusinessObject={currentBusinessObject}/>
                                </div>
                            </li>
                            <li>
                                <h2 id={"attributesSlide"}>
                                    <span style={{fontSize: 15}}>Attributes</span></h2>
                                <div>
                                    <BusinessObjectAttributesGrid
                                        currentBusinessObject={currentBusinessObject}
                                        currentAttribute={currentAttribute}/>
                                </div>
                            </li>
                            <li>
                                <h2 id={"relationshipsSlide"}>
                                    <span style={{fontSize: 15}}>Relationships</span></h2>
                                <div>
                                    <BusinessObjectRelationshipsGrid
                                        currentBusinessObject={currentBusinessObject}
                                        currentRelationship={currentRelationship}/>
                                </div>
                            </li>
                            <li>
                                <h2 id={"valueListSide"}>
                                    <span style={{fontSize: 15}}>Value List</span></h2>
                                <div>
                                    <BusinessObjectAttributeValueListGrid
                                        currentAttribute={currentAttribute}
                                        currentBusinessObject={currentBusinessObject}
                                        currentAttributeValue={currentAttributeValue}
                                    />
                                </div>
                            </li>
                            <li>
                                <h2 id={"layoutSlide"}>
                                    <span style={{fontSize: 15}}>Diagram</span></h2>
                                <div>
                                    <BusinessObjectsLayout currentBusinessObject={currentBusinessObject}/>
                                </div>
                            </li>
                        </ol>
                    </div>
                </div>
            </Hotkeys>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        businessObjectsWrapper: state.boCore.businessObjectsWrapper
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchAllBusinessObjects: () => {
            dispatch(fetchAllBusinessObjects());
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(BusinessObjects)



// WEBPACK FOOTER //
// ./app/views/bo-core/BusinessObjects.tsx